module.exports = "#append_wrapper>.row:first-child {display:none;}\n.mt30{\n    margin-right: 85px;\n}"